const MILLISECONDS_PER_DAY = 24 * 60 * 60 * 1000;

/**
 * Whole calendar days past the due date (0 if not yet due). Compares date-only, ignoring time-of-day.
 */
export function calculateDaysOverdue(dueDate: Date | string | null | undefined): number {
  if (!dueDate) {
    return 0;
  }

  const parsedDueDate = dueDate instanceof Date ? dueDate : new Date(dueDate);
  if (Number.isNaN(parsedDueDate.getTime())) {
    return 0;
  }

  const dueDateOnly = new Date(
    parsedDueDate.getFullYear(),
    parsedDueDate.getMonth(),
    parsedDueDate.getDate(),
  );
  const today = new Date();
  const todayOnly = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  return Math.max(0, Math.floor((todayOnly.getTime() - dueDateOnly.getTime()) / MILLISECONDS_PER_DAY));
}
